/**
 * Trader Theme Context
 * Provides dark/light theme toggle for WebTrader
 */
import { createContext, useContext, useState, useEffect } from 'react';

const TraderThemeContext = createContext();

export const TraderThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('trader_theme');
    return saved || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('trader_theme', theme);
    // Apply theme class to root element
    if (theme === 'dark') {
      document.documentElement.classList.add('trader-dark');
      document.documentElement.classList.remove('trader-light');
    } else {
      document.documentElement.classList.add('trader-light');
      document.documentElement.classList.remove('trader-dark');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  return (
    <TraderThemeContext.Provider value={{ theme, toggleTheme, isDark }}>
      {children}
    </TraderThemeContext.Provider>
  );
};

export const useTraderTheme = () => {
  const context = useContext(TraderThemeContext);
  if (!context) {
    throw new Error('useTraderTheme must be used within TraderThemeProvider');
  }
  return context;
};
